import { useV2Translation } from 'pages/signup/steps/OrganizationName/v2/translation';
import { useSelector } from 'react-redux';
import { AppState } from 'store';
import { Features } from 'store/featureFlags/types';
import { Country } from 'store/signup/types';
import { FlagImage, SelectCountry, SelectFlag } from './style';
import { pushEvent } from 'utils/clevertapUtils';
import {
    CLICK_ORG_NAME_COUNTRY_DROPDOWN,
    CLICK_ORG_NAME_COUNTRY_OPTION,
} from 'utils/clevertapEvents';
import usFlag from '../../../../assets/usFlag.svg';
import bsFlag from '../../../../assets/bsFlag.svg';
import { MenuItem, Typography } from '@mui/material';
import { SEARCH_EXPERIMENT, SEARCH_UI_EXPERIMENT } from 'utils/clevertapVariantFlags';

export const CountrySelect: React.FC<{
    country: Country;
    setCountry: (value: Country) => void;
}> = ({ country, setCountry }) => {
    const copy = useV2Translation();
    const { newSearchUIEnabled, v2SearchAPIEnabled } = useSelector(
        (state: AppState) => ({
            newSearchUIEnabled:
                state.FeatureFlagging.features[Features.SEARCH_UI_V2],
            v2SearchAPIEnabled:
                state.FeatureFlagging.features[Features.SEARCH_API_V2],
        }),
    );

    return (
        <SelectCountry
            value={country}
            onChange={(e) => setCountry(e.target.value as Country)}
            onClick={() =>
                pushEvent(CLICK_ORG_NAME_COUNTRY_DROPDOWN, {
                    [SEARCH_EXPERIMENT]: v2SearchAPIEnabled ? 'on' : 'off',
                    [SEARCH_UI_EXPERIMENT]: newSearchUIEnabled ? 'on' : 'off',
                })
            }
            variant="standard"
            disableUnderline
            renderValue={(selected) => (
                <SelectFlag src={selected === 'bs' ? bsFlag : usFlag} alt="" />
            )}
            MenuProps={{
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                },
            }}
        >
            <MenuItem
                key="us"
                onClick={() =>
                    pushEvent(CLICK_ORG_NAME_COUNTRY_OPTION, {
                        [SEARCH_EXPERIMENT]: v2SearchAPIEnabled ? 'on' : 'off',
                        [SEARCH_UI_EXPERIMENT]: newSearchUIEnabled ? 'on' : 'off',
                    })
                }
                value="us"
            >
                <FlagImage src={usFlag} alt="" />

                <Typography variant="body1">{copy.unitedStates}</Typography>
            </MenuItem>
            <MenuItem
                key="bs"
                onClick={() =>
                    pushEvent(CLICK_ORG_NAME_COUNTRY_OPTION, {
                        [SEARCH_EXPERIMENT]: v2SearchAPIEnabled ? 'on' : 'off',
                        [SEARCH_UI_EXPERIMENT]: newSearchUIEnabled ? 'on' : 'off',
                    })
                }
                value="bs"
            >
                <FlagImage src={bsFlag} alt="" />

                <Typography variant="body1">{copy.bahamas}</Typography>
            </MenuItem>
        </SelectCountry>
    );
};
